import React from "react";
import { CollapseFAQ, H3, NamedLink } from '../../../components';
import { FormattedMessage } from '../../../util/reactIntl';

import ContinueIcon from '../../TopbarContainer/Topbar/images/continue-icon.svg';
import CatImage from '../images/Tallisker 1 - Crop - Burmese cat with ribbon.jpg';

import css from '../PetSittingServicesPage.module.css';
import { catFaq } from "./faqs";
import { userTypes } from "../../../util/userTypes";
import AvatarPlaceholder from '../images/avatar_placeholder.png';
import SectionHero from "../../../components/StaticPageContainers/SectionHero";
import SectionGrid421 from "../../../components/StaticPageContainers/SectionGrid421";
import SectionGrid41 from "../../../components/StaticPageContainers/SectionGrid41";
import SectionGrid21 from "../../../components/StaticPageContainers/SectionGrid21";
import SectionGrid31 from "../../../components/StaticPageContainers/SectionGrid31";
import SectionSimpleContainer from "../../../components/StaticPageContainers/SectionSimpleContainer";
import TrustWidgetSmall from "../../../components/StaticPageContainers/TrustWidgetSmall";

const CatPage = props => {
    return (
        <div className={css.root}>

            <SectionHero
                imageUrl={CatImage}
                header={
                    <H3>
                        Trusted In-Home Cat Sitting Services
                    </H3>
                }
                content={
                    <>
                        <p className={css.info}>
                            Keep your cat relaxed at home with caring, verified sitters. Whether you need reliable in-home cat care or want to find cat sitting opportunities, HouseSit Match connects owners and sitters in a safe, supportive community.
                        </p>

                        <div className="rowMobile fitWidth cenSelf gap20">
                            <NamedLink
                                className={css.ctaButton}
                                name="SearchHouseSitterPage">
                                Find a cat sitter
                                <img src={ContinueIcon} className={css.icon} />
                            </NamedLink>

                            <NamedLink
                                className={css.ctaButton}
                                name="SearchHouseSitterPage"
                            >
                                Find cat sitting opportunities
                                <img src={ContinueIcon} className={css.icon} />
                            </NamedLink>
                        </div>

                        {/* <p className={css.info}>
                            ⭐ Rated Excellent on Trustpilot (4.8 / 5) • Verified members • UK-based support since 2013
                        </p> */}
                        <TrustWidgetSmall text={"• Verified members • UK-based support since 2013"} />
                    </>}
            />

            <SectionGrid421
                backgroundColor="white"
                header={
                    <>
                        <p className={css.sectionTitle}>
                            Why Choose HouseSit Match for Cat Sitting
                        </p>

                        <p className={css.info}>
                            Cats do best at home where routine and scent are familiar. With HouseSit Match you

                            <NamedLink className={css.link}
                                name="SearchHouseSitterPage">
                                find verified sitters
                            </NamedLink>
                            with visible reviews who follow your care plan, manage litter and meds and send daily updates.
                        </p>
                    </>
                }
                content={
                    <>
                        <div className={css.card}>
                            <H3>
                                Home comfort for cats
                            </H3>
                            <p className={css.info}>
                                🏠︎ Familiar scents and spaces keep stress low so your cat stays settled.
                            </p>
                        </div>
                        <div className={css.card}>
                            <H3>
                                Cat-specific care
                            </H3>
                            <p className={css.info}>
                                ✚ Exact feeding and litter hygiene with medication and gentle enrichment play.
                            </p>
                        </div>
                        <div className={css.card}>
                            <H3>
                                Verified sitters you can check
                            </H3>
                            <p className={css.info}>
                                👤︎ ID checks and visible reviews help you choose with confidence.
                            </p>
                        </div>
                        <div className={css.card}>
                            <H3>
                                Quick matching and real support
                            </H3>
                            <p className={css.info}>
                                🤝︎ Useful filters, secure chat and a helpful team if you need a hand.
                            </p>
                        </div>

                    </>
                }
                footer={
                    <>
                        <p className={css.info}>
                            Useful filters, secure chat and a helpful team if you need a hand.
                        </p>

                        <div className="col cenV fitWidth cenSelf gap20">
                            <NamedLink
                                className={css.ctaButton}
                                name="ManageListingsPage">
                                List your cat sitting request
                                <img src={ContinueIcon} className={css.icon} />
                            </NamedLink>

                            <div className='row'>
                                Are you a sitter •
                                <NamedLink
                                    className={css.link}
                                    name="SearchHouseSitPage">
                                    See cat sitting opportunities
                                </NamedLink>

                            </div>
                        </div>
                    </>
                } />

            <SectionGrid41
                header={
                    <>
                        <p className={css.sectionTitle}>
                            How Cat Sitting Works
                        </p>
                        <p className={css.info}>
                            Booking a cat sitter on HouseSit Match is simple. Share your cat’s routine, meet verified sitters and confirm the plan in a few clicks.
                        </p>
                    </>
                }
                content={
                    <>
                        <div className={css.stepContainer}>
                            <H3>
                                <span class={css.circleNumber}>1</span>
                                Tell us about your cat
                            </H3>
                            <p className={css.info}>
                                Share your cat’s routine like feeding times and litter care along with any medication.
                            </p>
                        </div>
                        <div className={css.stepContainer}>
                            <H3>
                                <span class={css.circleNumber}>2</span>
                                Meet the right sitters
                            </H3>
                            <p className={css.info}>
                                Browse verified profiles that match your dates and location. Check IDs and reviews to feel confident.
                            </p>
                        </div>
                        <div className={css.stepContainer}>
                            <H3>
                                <span class={css.circleNumber}>3</span>
                                Message and confirm
                            </H3>
                            <p className={css.info}>
                                Chat in the platform, arrange a video call and agree on responsibilities and timing. See FAQs for medication and shy-cat guidance.
                            </p>
                        </div>
                        <div className={css.stepContainer}>
                            <H3>
                                <span class={css.circleNumber}>4</span>
                                Enjoy stress-free travel
                            </H3>
                            <p className={css.info}>
                                Your cat stays at home, keeps their routine and you receive regular updates. Leave a review at the end to help others.
                            </p>
                        </div>
                    </>
                }
                footer={
                    <>
                        <div className="col cenV fitWidth cenSelf gap20">
                            <NamedLink
                                className={css.ctaButton}
                                name="SearchHouseSitterPage">
                                Find a cat sitter
                                <img src={ContinueIcon} className={css.icon} />
                            </NamedLink>

                            <div className='row'>
                                New to this •
                                <NamedLink
                                    className={css.link}
                                    name="WhatIsHouseSittingPage">
                                    How house and pet sitting works
                                </NamedLink>

                            </div>
                        </div>
                    </>
                } />

            <SectionGrid21
                backgroundColor="white"
                header={
                    <>
                        <p className={css.sectionTitle}>
                            For Cat Owners
                        </p>

                        <p className={css.info}>
                            Keep your cat at home with a sitter who follows your plan. You choose the person, set the routine and get daily updates.
                        </p>

                        <p className={css.subtitle}>
                            What you can expect:
                        </p>
                    </>}
                content={
                    <>
                        <p className={css.info}>
                            • Feeding at your usual times and clean litter care
                        </p>
                        <p className={css.info}>
                            • Calm company and gentle play that suits your cat
                        </p>
                        <p className={css.info}>
                            • Medication given as instructed with clear notes
                        </p>
                        <p className={css.info}>
                            • Water plants, bring in post and keep things tidy
                        </p>
                        <p className={css.info}>
                            • Daily photo updates so you can relax while away
                        </p>
                    </>
                }
                footer={<>

                    <div className="col cenV fitWidth cenSelf gap20">
                        <NamedLink
                            className={css.ctaButton}
                            name="MembershipPlansPage"
                            params={{ accountType: userTypes.homeowner }}>
                            Compare owner plans
                            <img src={ContinueIcon} className={css.icon} />
                        </NamedLink>
                    </div>
                </>
                } />

            <SectionGrid21
                header={
                    <>
                        <p className={css.sectionTitle}>
                            For Cat Sitters
                        </p>

                        <p className={css.info}>
                            Find rewarding cat sits that fit your schedule. Build a trusted profile, meet caring owners and look after cats in their own homes.
                        </p>

                        <p className={css.subtitle}>
                            What you can expect:
                        </p>

                    </>}
                content={<>
                    <p className={css.info}>
                        •  <NamedLink
                            className={css.link}
                            name="SearchHouseSitPage">
                            Search
                        </NamedLink> sits by dates, location and house type
                    </p>
                    <p className={css.info}>
                        • Filter for cats and read clear care notes
                    </p>
                    <p className={css.info}>
                        • Boost trust with ID checks and references
                    </p>
                    <p className={css.info}>
                        • Chat with owners and agree the plan in writing
                    </p>
                    <p className={css.info}>
                        • Collect reviews to unlock more cat sitting opportunities
                    </p>
                </>
                }
                footer={<>
                    <div className="col cenV fitWidth cenSelf gap20">
                        <NamedLink
                            className={css.ctaButton}
                            name="MembershipPlansPage"
                            params={{ accountType: userTypes.housesitter }}>
                            See sitter plans
                            <img src={ContinueIcon} className={css.icon} />
                        </NamedLink>
                    </div>
                </>} />


            <SectionGrid31
                backgroundColor="white"
                header={<>
                    <p className={css.sectionTitle}>
                        What Cat Owners Say
                    </p>

                    <p className={css.info}>
                        Real experiences from owners who chose in-home cat sitting on HouseSit Match.
                    </p>
                </>}
                content={<>
                    <div className={css.card}>
                        <img src={AvatarPlaceholder} className={css.reviewerImage} />

                        <p className={css.info}>
                            “Came home to a relaxed cat and a tidy flat. Daily photos made our trip stress free.”
                        </p>
                        <p className={css.reviewer}>
                            — Emma • London
                        </p>

                    </div>

                    <div className={css.card}>
                        <img src={AvatarPlaceholder} className={css.reviewerImage} />

                        <p className={css.info}>
                            “Our sitter followed the feeding and medication plan perfectly. We will book again.”
                        </p>
                        <p className={css.reviewer}>
                            — Martin • Bristol
                        </p>

                    </div>

                    <div className={css.card}>
                        <img src={AvatarPlaceholder} className={css.reviewerImage} />

                        <p className={css.info}>
                            “First time using a sitter and it was brilliant. Our shy cat warmed up within a day.”
                        </p>
                        <p className={css.reviewer}>
                            — Dolly • Edinburgh
                        </p>

                    </div>
                </>}
                footer={
                    // <div className="col cenV fitWidth cenSelf gap20">
                    //     ⭐ Trustpilot 4.8/5 from nearly 400 reviews • Google Reviews 4.7/5 from 35 reviews

                    //     <a href="https://uk.trustpilot.com/review/housesitmatch.com" target="_blank" rel="noopener noreferrer">
                    //         Read more reviews on Trustpilot
                    //     </a>
                    // </div>
                    <TrustWidgetSmall text={"• Google Reviews 4.7/5 from 35 reviews"} />
                } />


            <SectionGrid21
                header={<>
                    <p className={css.sectionTitle}>
                        We Support Cat Welfare
                    </p>


                    <p className={css.info}>
                        We care about cats staying safe and well at home and in the community.
                    </p>
                </>}
                content={<>
                    <div className={css.stepContainer}>
                        <p className={css.subtitle}>
                            Charity and Community
                        </p>
                        <p className={css.info}>
                            • We promote responsible cat care and adoption
                        </p>
                        <p className={css.info}>
                            • We highlight partner charities and education projects
                        </p>
                        <p className={css.info}>
                            • A share of activity supports welfare initiatives across our network
                        </p>
                    </div>

                    <div className={css.stepContainer}>
                        <p className={css.subtitle}>
                            24/7 Vet Advice Line
                        </p>
                        <p className={css.info}>
                            • Access to a vet advice line for guidance during sits
                        </p>
                        <p className={css.info}>
                            • Help with routine questions like appetite changes or litter issues
                        </p>
                        <p className={css.info}>
                            • Advice is not a substitute for emergency care
                        </p>
                    </div>
                </>} />


            <SectionGrid21
                backgroundColor="white"
                header={
                    <>
                        <p className={css.sectionTitle}>
                            Membership and Pricing
                        </p>


                        <p className={css.info}>
                            HouseSit Match runs on simple annual memberships for owners and sitters.

                            <NamedLink
                                className={css.link}
                                name="SignupPage"
                            >
                                Join
                            </NamedLink>
                            to contact matches safely, confirm a booking and build reviews. Choose the plan that fits how you use the platform.
                        </p>
                    </>
                }
                content={
                    <>
                        <div className={css.card}>
                            <p className={css.subtitle}>
                                Owners membership - what it unlocks
                            </p>
                            <p className={css.info}>
                                ✔ Create a detailed cat sitting request and publish it
                            </p>
                            <p className={css.info}>
                                ✔ Receive applications and send invites to promising sitters
                            </p>
                            <p className={css.info}>
                                ✔ Shortlist, confirm the booking and share your care plan
                            </p>
                            <p className={css.info}>
                                ✔ Leave a review to help the next owner and grow trust
                            </p>
                        </div>

                        <div className={css.card}>
                            <p className={css.subtitle}>
                                Sitters membership - what it unlocks
                            </p>
                            <p className={css.info}>
                                ✔ Build a profile that shows your cat experience and checks
                            </p>
                            <p className={css.info}>
                                ✔ Set your availability and apply to sits that fit your dates
                            </p>
                            <p className={css.info}>
                                ✔ Chat with owners to agree the plan and house access
                            </p>
                            <p className={css.info}>
                                ✔ Collect reviews to unlock more opportunities
                            </p>
                        </div>
                    </>
                }
                footer={
                    <>
                        <div className={css.card}>
                            <p className={css.subtitle}>
                                Shared features for both
                            </p>
                            <p className={css.info}>
                                ✔ Secure messaging and clear verification badges
                            </p>
                            <p className={css.info}>
                                ✔ Helpful guides and support if you need a hand
                            </p>
                        </div>

                        <div className="row cenV fitWidth cenSelf gap20">
                            <NamedLink
                                className={css.ctaButton}
                                name="MembershipPlansPage"
                                params={{ accountType: userTypes.homeowner }}>
                                Compare owner plans
                                <img src={ContinueIcon} className={css.icon} />
                            </NamedLink>

                            <NamedLink
                                className={css.ctaButton}
                                name="MembershipPlansPage"
                                params={{ accountType: userTypes.housesitter }}>
                                See sitter plans
                                <img src={ContinueIcon} className={css.icon} />
                            </NamedLink>
                        </div>
                    </>
                } />


            <SectionSimpleContainer
                header={
                    <p className={css.sectionTitle}>
                        FAQs About Cat Sitting Services
                    </p>
                }
                content={
                    <CollapseFAQ
                        list={catFaq}
                    />
                } />


            <SectionSimpleContainer
                backgroundColor="white"
                header={
                    <>
                        <p className={css.sectionTitle}>
                            Get Started with HouseSit Match
                        </p>
                        <p className={css.info}>
                            HouseSit Match helps cat owners find caring, verified sitters and helps sitters discover trusted opportunities. Create your free account to set up your profile, explore the platform and choose a membership when you are ready to contact or apply.
                        </p>
                    </>}
                footer={<>
                    <div className="col cenV fitWidth cenSelf gap20">
                        <NamedLink
                            className={css.ctaButton}
                            name="SignupPage">
                            Create your free account
                            <img src={ContinueIcon} className={css.icon} />
                        </NamedLink>

                        <div className='row'>
                            Are you a sitter? •
                            <NamedLink
                                className={css.link}
                                name="MembershipPlansPage"
                                params={{ accountType: userTypes.homeowner }}>
                                See sitter membership plans
                            </NamedLink>

                        </div>
                    </div>
                </>
                }
            />

        </div >
    )
};

export default CatPage;